// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconView__icon-ff5b43 {
  fill: var(--base-120);
}

.IconView__theme-dark-fe44eb {
  fill: var(--addition-50);
}

.IconView__theme-inherit-ac0105 {
  fill: currentColor;
}

.IconView__auto-c4a333 {
  width: auto;
  height: auto;
}

.IconView__big-ba8783 {
  width: 32px;
  height: 32px;
}

.IconView__large-ee4133 {
  width: 32px;
  height: 32px;
}

.IconView__mlarge-a446a7 {
  width: 32px;
  height: 32px;
}

.IconView__xlarge-a9a6b4 {
  width: 32px;
  height: 32px;
}

.IconView__xxlarge-e1d4b6 {
  width: 48px;
  height: 48px;
}

.IconView__huge-aa36d0 {
  width: 56px;
  height: 56px;
}

.IconView__medium-ae6ae7 {
  width: 24px;
  height: 24px;
}

.IconView__small-b0c161 {
  width: 16px;
  height: 16px;
}

.IconView__xsmall-cf0839 {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/IconView/IconView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF","sourcesContent":[".icon {\n  fill: var(--base-120);\n}\n\n.theme-dark {\n  fill: var(--addition-50);\n}\n\n.theme-inherit {\n  fill: currentColor;\n}\n\n.auto {\n  width: auto;\n  height: auto;\n}\n\n.big {\n  width: 32px;\n  height: 32px;\n}\n\n.large {\n  width: 32px;\n  height: 32px;\n}\n\n.mlarge {\n  width: 32px;\n  height: 32px;\n}\n\n.xlarge {\n  width: 32px;\n  height: 32px;\n}\n\n.xxlarge {\n  width: 48px;\n  height: 48px;\n}\n\n.huge {\n  width: 56px;\n  height: 56px;\n}\n\n.medium {\n  width: 24px;\n  height: 24px;\n}\n\n.small {\n  width: 16px;\n  height: 16px;\n}\n\n.xsmall {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `IconView__icon-ff5b43`,
	"theme-dark": `IconView__theme-dark-fe44eb`,
	"themeDark": `IconView__theme-dark-fe44eb`,
	"theme-inherit": `IconView__theme-inherit-ac0105`,
	"themeInherit": `IconView__theme-inherit-ac0105`,
	"auto": `IconView__auto-c4a333`,
	"big": `IconView__big-ba8783`,
	"large": `IconView__large-ee4133`,
	"mlarge": `IconView__mlarge-a446a7`,
	"xlarge": `IconView__xlarge-a9a6b4`,
	"xxlarge": `IconView__xxlarge-e1d4b6`,
	"huge": `IconView__huge-aa36d0`,
	"medium": `IconView__medium-ae6ae7`,
	"small": `IconView__small-b0c161`,
	"xsmall": `IconView__xsmall-cf0839`
};
module.exports = ___CSS_LOADER_EXPORT___;
